// utils/canvasHelpers.js

/**
 * Converts raw mouse event to canvas-relative coordinates.
 */
export const getMouseCoordinates = (e, canvas, scale) => {
  const rect = canvas.getBoundingClientRect();
  const mouseX = e.clientX - rect.left;
  const mouseY = e.clientY - rect.top;

  return {
    x: mouseX / scale,
    y: mouseY / scale,
  };
};
